export default "__VITE_ASSET__o38wAtpS__"